function r(r,n){for(var t=-1,a=null==r?0:r.length,e=0,l=[];++t<a;){var u=r[t];n(u,t,r)&&(l[e++]=u)}return l}export{r as default};
//# sourceMappingURL=_arrayFilter.js.map
